import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import { VISION_ILLUSTRATION } from "../../constants/imageConstants";
import { useHomepageData } from "../../hooks/useHomepageData";

function VisionSectionContent({ visionData }: { visionData: any }) {
  const [isVisible, setIsVisible] = useState(false);
  const [showVision, setShowVision] = useState(true);

  useEffect(() => {
    // Initial fade-in
    setTimeout(() => setIsVisible(true), 500);

    // Switch between vision and mission
    const interval = setInterval(() => {
      setShowVision((prev) => !prev);
    }, 10000); // 10s duration matches transition

    return () => clearInterval(interval);
  }, []);

  return (
    <section
      className="relative px-4 lg:px-16 py-16 lg:py-24 my-16 flex items-center justify-center"
      aria-labelledby="vision-heading"
    >
      <div className="relative w-full h-40">
        <motion.img
          src={VISION_ILLUSTRATION}
          alt="Illustration"
          aria-hidden="true"
          className="absolute left-1/2 transform -translate-x-1/2 sm:-top-16 -top-24 w-full h-[135px] animate-pulse object-contain pointer-events-none"
        />

          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-full text-center px-4">
              <AnimatePresence mode="wait">
                <motion.div
                  key={showVision ? "vision" : "mission"}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: isVisible ? 1 : 0 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 1, ease: "easeInOut" }}
                  className="flex flex-col items-center justify-center"
                >
                  <motion.h2
                    id="vision-heading"
                    className="text-4xl lg:text-6xl font-medium text-[#d9d9d9] tracking-wide"
                    initial={{ y: -30 }}
                    animate={{ y: 0 }}
                    exit={{ y: -30 }}
                    transition={{ duration: 1, ease: "easeInOut" }}
                  >
                    {showVision
                      ? visionData.vision.title
                      : visionData.mission.title}
                  </motion.h2>

                  <motion.p 
                    className="mt-16 sm:mt-20 text-xl sm:text-2xl lg:text-3xl text-white leading-relaxed px-2 sm:px-8"
                    initial={{ y: 30 }}
                    animate={{ y: 0 }}
                    exit={{ y: 30 }}
                    transition={{ duration: 1, ease: "easeInOut" }}
                  >
                    {showVision
                      ? visionData.vision.description
                      : visionData.mission.description}
                  </motion.p>
                </motion.div>
              </AnimatePresence>
            </div>
          </div>
      </div>
    </section>
  );
}

export default function VisionSection() {
  const { data } = useHomepageData();
  return <VisionSectionContent visionData={data.visionSection} />;
}
